import { HEADERS } from './fixtures';
import { optionActions } from 'core/Option';
import { useHistory } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import {
    ButtonFooter,
    ExpandButton,
    Table
} from 'mol-ui';
import {
    Container,
    TableContainer
} from './styled';
import React, { useEffect } from 'react';
import {
    useDispatch,
    useSelector
} from 'hooks';

const RiskAgentListing = () => {

    const dispatch = useDispatch();
    const { t } = useTranslation();
    const { push } = useHistory();

    const {
        riskAgents,
        riskAgentsLoading
    } = useSelector('option');

    useEffect(() => {
        dispatch(optionActions.getRiskAgents());
    }, []);

    const actionController = [{
        icon: 'search',
        onClick: ({ id }) => push(`${ t('/agentes') }/${ id }`),
        title: t('Ver')
    }];

    return (
        <Container>
            <TableContainer>
                <Table
                    config={ HEADERS }
                    data={ riskAgents }
                    loading={ riskAgentsLoading }
                    rowActions={ actionController }
                />
            </TableContainer>
            <ButtonFooter>
                <ExpandButton
                    caption={ t('Nuevo agente de riesgo') }
                    icon="add"
                    size={ 100 }
                    width={ 200 }
                    onClick={ () => push(t('/agentes/crear')) }
                />
            </ButtonFooter>
        </Container>
    );
};

export default RiskAgentListing;
